import { Injectable } from '@angular/core';
import { ENDPOINTS, getUuidV4, OdataService, TravelStatusUpdateModel } from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OdataTravelStatusUpdateService {
    public constructor(private readonly odataService: OdataService) {}

    public saveStatus(travelStatusUpdate: TravelStatusUpdateModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            travelStatusUpdate,
            ENDPOINTS.StatusUpdate,
            `${travelStatusUpdate.mType.value}-${travelStatusUpdate.notification.identifier.toString()}-${getUuidV4()}`,
        );
    }
}
